export default __webpack_public_path__ + "static/media/dreadweapon.7a206bf1.png";